<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="col-md-12 order-md-1 p-0">
  <form class="form" (ngSubmit)="onSave()" [formGroup]="eventForm" novalidate>
    <div class="sticky-top bg-light pt-2">
      <div class="row">
        <div class="col-sm-6 pull-left">
          <button class="btn btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
        </div>
        <div class="col-sm-6 text-right pull-right">
          <a class="btn btn-secondary mr-1" target="_blank" [routerLink]="['/events/', event.id]"
             type="button">Preview</a>
          <button class="btn btn-primary" [promiseBtn]="submitComplete" type="submit">Save</button>
        </div>
      </div>
      <hr class="mb-4"/>
    </div>
    <h4 *ngIf="eventId" class="mb-3">Edit Event</h4>
    <h4 *ngIf="!eventId" class="mb-3">Add Event</h4>
    <div class="card mb-5">
      <div class="card-header pb-0">
        <div class="row p-0">
          <div class="col-md-6">
            <h5 class="m-0">Speaker Title & Details</h5>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="media align-items-center mb-7">
          <div class="u-lg-avatar mr-3">
            <span *ngIf="!croppedImage" class="btn btn-lg btn-icon btn-dark rounded-circle mr-3">
              <span
                class="btn-icon__inner">{{ auth.user.firstName.substr(0, 1).toUpperCase() }}{{ auth.user.lastName.substr(0, 1).toUpperCase() }}</span>
            </span>
            <img *ngIf="croppedImage" class="img-fluid" [src]="croppedImage"/>
          </div>

          <div class="media-body">
            <button type="button" (click)="editImage(content)"
                    class="btn btn-sm btn-primary transition-3d-hover mb-1 mr-2 mb-sm-0">Upload Headshot
            </button>
            <button type="button" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">Delete</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-5">
            <label for="firstName">First name</label>
            <input type="text" class="form-control" formControlName="firstName"/>
            <div class="invalid-message">
              <div>First Name is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="country">Last name</label>
            <input type="text" class="form-control" formControlName="lastName"/>
            <div class="invalid-message">
              <div>Last Name is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="country">Credentials</label>
            <input type="text" class="form-control" placeholder="Ph.D, BCBA-D" formControlName="credentials"/>
            <div class="invalid-message">
              <div>Credentials is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="firstName">Certificant Number <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="certificantNumber"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb-5">
            <label for="firstName">Email</label>
            <input type="text" class="form-control" formControlName="email"/>
            <div class="invalid-message">
              <div>Email is required</div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <label for="firstName">Alternate Email <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="alternateEmail"/>
            <div class="invalid-message">
              <div>Not a valid email address</div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <label for="firstName">Phone <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="phoneNumber"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="zip">Biography</label>
            <ckeditor [editor]="Editor" formControlName="biography" [config]="htmlEditorConfig"
                      style="width: 100%"></ckeditor>
            <div class="invalid-message">
              <div>Company Description is required</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-5">
      <div class="card-header pb-0">
        <div class="row p-0">
          <div class="col-md-6">
            <h5 class="m-0">Event title and details</h5>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="event.conferenceName" class="row">
          <div class="col-md-8 mb-3">
            <label for="firstName">Conference</label>
            <i class="fa fa-asterisk"></i>
            <input type="text" disabled class="form-control" [value]="event.conferenceName"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mb-3">
            <label for="firstName">Event Title</label>
            <i class="fa fa-asterisk"></i>
            <input type="text" class="form-control" formControlName="title"/>
            <div class="invalid-message">
              <div>Event Title is required</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="firstName">Event Date</label>
            <i class="fa fa-asterisk"></i>
            <kendo-datepicker [disabled]="!event.instructorCanEdit" class="form-control" placeholder=""
                              formControlName="eventDateTime"></kendo-datepicker>
            <div class="invalid-message">
              <div>Event Date is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="firstName">Start Time</label>
            <i class="fa fa-asterisk"></i>
            <kendo-timepicker [disabled]="!event.instructorCanEdit" class="form-control" placeholder=""
                              formControlName="startTime"></kendo-timepicker>
            <div class="invalid-message">
              <div>Start Time is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="firstName">End Time</label>
            <i class="fa fa-asterisk"></i>
            <kendo-timepicker [disabled]="!event.instructorCanEdit" class="form-control" placeholder=""
                              formControlName="endTime"></kendo-timepicker>
            <div class="invalid-message">
              <div>End Time is required</div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="firstName">Timezone</label>
            <i class="fa fa-asterisk"></i>
            <select [disabled]="!event.instructorCanEdit" class="form-control" formControlName="timeZone">
              <option [value]="'America/New_York'">Eastern Standard Time</option>
              <option [value]="'America/Chicago'">Central Standard Time</option>
              <option [value]="'America/Denver'">Mountain Standard Time</option>
              <option [value]="'America/Los_Angeles'">Pacific Standard Time</option>
              <option [value]="'America/Phoenix'">Arizona Time</option>
              <option [value]="'Pacific/Honolulu'">Hawaii Standard Time</option>
              <option [value]="'Europe/Dublin'">Greenwich Mean Time (Dublin)</option>
              <option [value]="'Europe/Lisbon'">Western European Time</option>
              <option [value]="'Europe/London'">Greenwich Mean Time (London)</option>
              <option [value]="'Asia/Manila'">Philippine Standard Time</option>
            </select>
            <div class="invalid-message">
              <div>End Time is required</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div *ngIf="event.instructorCanEdit" class="col-md-2 mb-3">
            <label for="country">Price</label>
            <i class="fa fa-asterisk"></i>
            <kendo-numerictextbox [format]="'n2'" [min]="0" class="form-control"
                                  formControlName="price"></kendo-numerictextbox>
            <div class="invalid-message">
              <div>Price is required</div>
            </div>
          </div>
        </div>
      </div>

      <h5 class="card-header border-top">Continuing Education</h5>
      <div class="card-body">
        <div class="row no-gutters no-candidates" style="min-height: 200px"
             *ngIf="!certifications || certifications.length == 0">
          <div class="col-sm-12 my-auto">
            <h1><i class="fas fa-empty-set"></i></h1>
            <h4>No Certifications for this organization</h4>
            <p>This organization has not added any certifications yet. You will need to add certifications in order to
              offer CEs for this organization.</p>
          </div>
        </div>
        <ng-container formArrayName="ceus" *ngFor="let cert of certifications; let i = index">
          <div [formGroupName]="i" class="row mb-3">
            <div class="col-md-3">
              <label
                for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.baseTypeName }}  {{ cert.certificationBody.unitName }}</label>
              <i class="fa fa-asterisk"></i>
              <input type="hidden" formControlName="certificationBodyId"/>
              <select class="form-control" formControlName="ceuCount">
                <option [value]="0">0</option>
                <option [value]=".5">.5</option>
                <option [value]="1">1</option>
                <option [value]="1.5">1.5</option>
                <option [value]="2">2</option>
                <option [value]="2.5">2.5</option>
                <option [value]="3">3</option>
                <option [value]="3.5">3.5</option>
                <option [value]="4">4</option>
                <option [value]="4.5">4.5</option>
                <option [value]="5">5</option>
                <option [value]="5.5">5.5</option>
                <option [value]="6">6</option>
                <option [value]="6.5">6.5</option>
              </select>
              <div class="invalid-message">
                <div>{{ cert.certificationBody.baseTypeName }}  {{ cert.certificationBody.unitName }} are required</div>
              </div>
            </div>
            <div *ngIf="cert.certificationBody.subType1Name" class="col-md-3">
              <label
                for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType1Name }} {{ cert.certificationBody.unitName }}</label>
              <i class="fa fa-asterisk"></i>
              <select class="form-control" formControlName="subType1CeuCount">
                <option [value]="0">0</option>
                <option [value]=".5">.5</option>
                <option [value]="1">1</option>
                <option [value]="1.5">1.5</option>
                <option [value]="2">2</option>
                <option [value]="2.5">2.5</option>
                <option [value]="3">3</option>
                <option [value]="3.5">3.5</option>
                <option [value]="4">4</option>
                <option [value]="4.5">4.5</option>
                <option [value]="5">5</option>
                <option [value]="5.5">5.5</option>
                <option [value]="6">6</option>
                <option [value]="6.5">6.5</option>
              </select>
              <div class="invalid-message">
                <div>{{ cert.certificationBody.subType1Name }} {{ cert.certificationBody.unitName }} are required</div>
              </div>
            </div>
            <div *ngIf="cert.certificationBody.subType2Name" class="col-md-3">
              <label
                for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType2Name }} {{ cert.certificationBody.unitName }}</label>
              <i class="fa fa-asterisk"></i>
              <select class="form-control" formControlName="subType2CeuCount">
                <option [value]="0">0</option>
                <option [value]=".5">.5</option>
                <option [value]="1">1</option>
                <option [value]="1.5">1.5</option>
                <option [value]="2">2</option>
                <option [value]="2.5">2.5</option>
                <option [value]="3">3</option>
                <option [value]="3.5">3.5</option>
                <option [value]="4">4</option>
                <option [value]="4.5">4.5</option>
                <option [value]="5">5</option>
                <option [value]="5.5">5.5</option>
                <option [value]="6">6</option>
                <option [value]="6.5">6.5</option>
              </select>
              <div class="invalid-message">
                <div>{{ cert.certificationBody.subType2Name }} {{ cert.certificationBody.unitName }} are required</div>
              </div>
            </div>
            <div *ngIf="cert.certificationBody.subType3Name" class="col-md-3">
              <label
                for="country">{{ cert.certificationBody.shortName }} {{ cert.certificationBody.subType3Name }} {{ cert.certificationBody.unitName }}</label>
              <i class="fa fa-asterisk"></i>
              <select class="form-control" formControlName="subType3CeuCount">
                <option [value]="0">0</option>
                <option [value]=".5">.5</option>
                <option [value]="1">1</option>
                <option [value]="1.5">1.5</option>
                <option [value]="2">2</option>
                <option [value]="2.5">2.5</option>
                <option [value]="3">3</option>
                <option [value]="3.5">3.5</option>
                <option [value]="4">4</option>
                <option [value]="4.5">4.5</option>
                <option [value]="5">5</option>
                <option [value]="5.5">5.5</option>
                <option [value]="6">6</option>
                <option [value]="6.5">6.5</option>
              </select>
              <div class="invalid-message">
                <div>{{ cert.certificationBody.subType3Name }} {{ cert.certificationBody.unitName }} are required</div>

              </div>
            </div>
            <div *ngIf="$any(this.eventForm.controls.ceus).controls[i]?.errors?.totalCEUExceeded"
                 class="col-md-12 invalid-message-visible">
              <span *ngIf="cert.certificationBody.subType1Name">{{ cert.certificationBody.subType1Name }}</span> <span
              *ngIf="cert.certificationBody.subType2Name"> + {{ cert.certificationBody.subType2Name }}</span> <span
              *ngIf="cert.certificationBody.subType3Name"> + {{ cert.certificationBody.subType3Name }}</span> must not
              exceed {{ cert.certificationBody.baseTypeName }} count
            </div>
          </div>

        </ng-container>
      </div>

      <h5 class="card-header border-top">Abstract/Description<i class="fa fa-asterisk"></i></h5>
      <div class="card-body">
        <ckeditor [editor]="Editor" formControlName="description" [config]="htmlEditorConfig"
                  style="width: 100%"></ckeditor>
        <div class="invalid-message">
          <div>Description is required</div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 mb-3">
            <div class="d-flex justify-content-between">
              <label for="firstName">Learning Objective 1</label>
            </div>

            <textarea class="form-control" placeholder="Participants will..." maxlength="255"
                      formControlName="learningObjective1"></textarea>
          </div>
          <div class="col-md-12 mb-5">
            <div class="d-flex justify-content-between">
              <label for="firstName">Learning Objective 2</label>
            </div>
            <textarea class="form-control" placeholder="Participants will..." maxlength="255"
                      formControlName="learningObjective2"></textarea>
          </div>
          <div class="col-md-12 mb-5">
            <div class="d-flex justify-content-between">
              <label for="firstName">Learning Objective 3</label>
            </div>
            <textarea class="form-control" placeholder="Participants will..." maxlength="255"
                      formControlName="learningObjective3"></textarea>
          </div>
        </div>
      </div>
    </div>

  </form>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Edit Image</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-md-12 text-center">
        <label class="btn-bs-file btn btn-lg btn-primary">
          Choose an Image
          <input type="file" (change)="fileChangeEvent($event)"/>
        </label>

        <image-cropper [imageChangedEvent]="imageChangedEvent" [imageBase64]="initialCroppedImage"
                       [maintainAspectRatio]="true" [onlyScaleDown]="true" [aspectRatio]="1 / 1" [resizeToWidth]="512"
                       format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                       (loadImageFailed)="loadImageFailed()"></image-cropper>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
    </div>
  </ng-template>
</div>
